export default __webpack_public_path__ + "static/media/Administrators.267f9c92.svg";